<template>
  <div>
    <div>
      <!-- 搜索 -->
      <el-form :inline="true" :model="search" class="demo-form-inline">
        <div class="search">
          <el-form-item label="账单编号">
            <el-input v-model="search.billNum"></el-input>
          </el-form-item>
          <el-form-item label="主体名称">
            <el-select v-model="search.subjectId" placeholder="请选择" filterable>
              <el-option v-for="item in subjectList" :key="item.id" :label="item.subjectName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态">
            <el-select v-model="search.billStatusList" placeholder="请选择" filterable>
              <el-option v-for="item in assignLauchStatusList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="text-align: right">
            <el-button type="primary" @click="queryData" style="margin-right: 8px">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <table-total ref="total" :type="2" />
      <!-- 投放数据 -->
      <!-- 数据列表 -->
      <el-table :key="tableKey" ref="multipleTable" v-loading="listLoading" stripe :data="list" tooltip-effect="dark"
        style="width: 100%" :height="tableHeight">
        <el-table-column :show-overflow-tooltip="true" label="账单编号" min-width="80px">
          <template slot-scope="scope">{{
              emptyDeal(scope.row.billNum)
          }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="公司名称" min-width="80px">
          <template slot-scope="scope">{{
              emptyDeal(scope.row.subjectName)
          }}</template>
        </el-table-column>
        <!-- <el-table-column
            :show-overflow-tooltip="true"
            label="数据/订单额"
            min-width="80px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.billingType=='263'">{{moneyTrans(scope.row.billApprovalDataNums)}}</span>
              <span v-else>{{emptyDeal(scope.row.billApprovalDataNums)}}</span>
            </template>
          </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" label="佣金(含税)" min-width="80px">
          <template slot-scope="scope">{{
              moneyTrans(scope.row.billApprovalMoney)
          }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="佣金" min-width="80px">
          <template slot-scope="scope">{{
              moneyTrans(scope.row.billAmount)
          }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="结算状态" min-width="80px">
          <template slot-scope="scope">{{
              rementStatus(scope.row.billStatus)
          }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="操作" min-width="100px">
          <template slot-scope="scope">
            <div class="icon-table-handle">
              <el-button type="text" @click="handleCreate(scope.row.billId)">
                下载对账单
              </el-button>
            </div>
            <div class="icon-table-handle">
              <el-button type="text" @click="handleClick(scope.row)">
                查看详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="mt10">
        <el-pagination :key="pageInfo.currentPage" :current-page="pageInfo.currentPage" :page-size="pageInfo.limit"
          layout="total,sizes, prev, pager, next" :total="pageInfo.allCount" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </div>
    <template>
      <create-pdf :key="keyValue" ref="pdfmodel" @callback="handleCallBack" style="position: fixed; left: -10000px" />
    </template>
  </div>
</template>
<script>
import {
  getAppliedList,
  getAduserInfo,
  getBillDetailInfo
} from "@/api/bill";
import {
  emptyTrans,
  formatMoney,
  formatDate,
  getDictList,
  countCurrentPage
} from "@/api/dataTrans.js";
import TableTotal from "@/components/TableTotal";
import Setting from "@/settings.js";
import CreatePdf from "../pdf/createPdfFile.vue";
var { pageConfig } = Setting;
export default {
  components: {
    TableTotal,
    CreatePdf
  },
  data() {
    return {
      keyValue: 0,
      search: {
        subjectId: null,
        billStatusList: null,
        billNum: null
      },
      dialogDetail: false,
      productList: [],
      assignLauchStatusList: [
        { name: "待账单审核", id: 334 },
        { name: "账单作废", id: 335 },
        { name: "结算中", id: 336 },
        { name: "结算完成", id: 337 }
      ],
      list: [],
      tableKey: 0,
      pageInfo: {
        limit: pageConfig["limit"],
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      tableHeight: document.body.clientHeight - 400,
      listLoading: false,
      detailData: {},
      searchData: {},
      subjectList: [],
      rementStatusList: [],
      total: {},
      id: null
    };
  },
  mounted() {
    this.rementStatusList = getDictList(301);
    window.onresize = function () {
      this.tableHeight = document.body.clientHeight - 400;
    };
    this.getAduser();
    this.getList();
  },
  methods: {
    date(_val) {
      return formatDate(_val);
    },
    // 结算状态转换
    rementStatus(_val) {
      switch (_val) {
        // 待完善
        case 302:
          return "待账单审核";

        // 待账单审核
        case 303:
          return "待账单审核";

        // 待账单驳回
        case 304:
          return "账单作废";

        // 待申请收票
        case 305:
          return "结算中";

        // 收票驳回
        case 306:
          return "账单作废";

        // 待收票审核
        case 308:
          return "结算中";

        // 待申请支付
        case 309:
          return "结算中";

        // 待支付审核
        case 310:
          return "结算中";

        // 待支付确认
        case 311:
          return "结算中";

        // 支付完成
        case 312:
          return "结算完成";

        default:
          return "--";
      }
    },
    // 账单状态id转换
    serachIdTrans(_val) {
      switch (_val) {
        case 334:
          return [302, 303];
        case 335:
          return [304, 306];
        case 336:
          return [305, 308, 309, 310, 311];
        case 337:
          return [312];
        default:
          return null;
      }
    },
    // 数据获取
    getList() {
      var pramaList = {};
      // pramaList = this.search;
      pramaList = JSON.parse(JSON.stringify(this.search));
      pramaList.billStatusList = this.serachIdTrans(pramaList.billStatusList);
      getAppliedList({
        pageNo: this.pageInfo.currentPage,
        pageSize: this.pageInfo.limit,
        ...pramaList
      }).then(res => {
        if (res && res.code == 0) {
          this.list = res.data.items;
          this.pageInfo.allCount = res.data.total;
          var _totalApprovalMoney = 0,
            totalActualSettlementExpenditure = 0;
          if (res.data.additional) {
            _totalApprovalMoney = res.data.additional.totalApprovalMoney;
            totalActualSettlementExpenditure =
              res.data.additional.totalActualSettlementExpenditure;
          }
          var _totalData = [
            {
              title: "佣金(含税)",
              currentNum: countCurrentPage("billApprovalMoney", res.data.items),
              totalNum: _totalApprovalMoney
            },
            {
              title: "佣金",
              currentNum: countCurrentPage("billAmount", res.data.items),
              totalNum: totalActualSettlementExpenditure
            }
          ];
          this.$refs.total.initData(_totalData);
        }
      });
    },
    queryData() {
      this.pageInfo.currentPage = 1;
      this.getList();
    },
    resetSearch(formName) {
      this.search = this.$options.data().search;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getList();
    },
    emptyDeal(_val) {
      return emptyTrans(_val);
    },
    moneyTrans(_val) {
      return formatMoney(_val);
    },
    handleClick(rows) {
      this.$router.push({
        path: "/settlementdetails",
        query: { id: rows.billId, showStatus: rows.showStatus }
      });
    },
    getAduser() {
      const _this = this;
      let token = localStorage.getItem("token");
      getAduserInfo({ access_token: token }).then(res => {
        if (res && res.code == 0) {
          if (res.data) {
            res.data.forEach(item => {
              _this.subjectList.push(item);
            });
          }
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    //生成对账单
    handleCreate(_id) {
      const _this = this;
      _this.keyValue = _id;
      getBillDetailInfo({ billId: _id }).then(res => {
        if (res.code == "0") {
          _this.$refs.pdfmodel.initdata(res.data);
        }
      });
    },
    //生成PDF回调函数
    handleCallBack() {
    }
  }
};
</script>
<style scoped lang="scss">
/deep/.el-form-item__label {
  text-align: left;
}

/deep/.el-input {
  width: 100%;
}

/deep/ .el-select {
  width: 100%;
}

/deep/.el-form-item {
  margin-bottom: 16px;
}

/deep/.el-form-item {
  width: 90%;
  margin-bottom: 22px;
}

.list-container {
  background-color: #fff;
  padding: 24px;
  margin-right: 24px;
}

.operate-button {
  color: rgba(19, 194, 194, 0.85);
}

.operate-button:hover {
  color: #13c2c2;
}
</style>
